import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import Button from '../../../../Form/Button';
import clsx from 'clsx';
import ImportParticipantsStore from '../../Store';
import { ParticipantImportFileRow } from '../../Store/Types';
import Table from './Table';
import LoadingIndicator from '../../../../LoadingIndicator';

interface Props {
  store: ImportParticipantsStore;
  filename: string;
  rows: ParticipantImportFileRow[];
}

const PreviewTable: React.FC<Props> = ({ store, filename, rows }) => {
  return (
    <div className="flex flex-col items-center px-2.5 py-5 lg:px-14">
      <div className="lg:w-[55%]">
        <h5 className="text-lg font-bold">
          <T kind="Table Preview" />
        </h5>
        <p className="mb-7 text-base">
          <T
            kind="Showing {{count}} records for <filename/>"
            count={rows.length}
            filename={<span className="font-bold">{filename}</span>}
          />
        </p>
        <div
          className={clsx(
            'mb-7 flex max-h-[calc(100vh-500px)] justify-center overflow-auto',
            'rounded-md border border-solid bg-gray-50',
          )}
        >
          <Table participants={rows} />
        </div>
        <div className="mt-5">
          <p className="text-center text-base">
            <T kind="If the preview of your upload looks accurate..." />
          </p>
          <div className="mt-5 flex justify-center">
            <Button
              type="button"
              onClick={store.uploadingReady}
              value="Upload a new file"
              className={clsx(
                'cursor-pointer rounded-md border border-solid font-semibold',
                'mr-2 bg-white px-4 py-2 text-lg font-medium disabled:opacity-50',
              )}
              disabled={store.importButtonDisabled}
            />
            <button
              className={clsx(
                'cursor-pointer rounded-md border border-solid font-semibold',
                'ml-2 bg-green-600 px-4 py-2 text-lg font-medium text-white disabled:opacity-50',
                'flex items-center',
              )}
              onClick={store.submit}
              disabled={store.importButtonDisabled}
            >
              <LoadingIndicator
                type="spin"
                color="#fff"
                width="20px"
                height="20px"
                delay={0}
                className={clsx('mr-2', store.importButtonDisabled ? '' : 'hidden')}
              />
              <T kind="Import {{count}} participant" count={rows.length} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(PreviewTable);
